import { render, staticRenderFns } from "./JcomZoneBoardMembersEdit.vue?vue&type=template&id=09f6f5a0"
import script from "./JcomZoneBoardMembersEdit.vue?vue&type=script&lang=js"
export * from "./JcomZoneBoardMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomZoneBoardMembersEdit.vue?vue&type=style&index=0&id=09f6f5a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports